<script setup lang="ts">
import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
} from "reka-ui";
import { ChevronDown } from "@/components/icons";

defineProps<{
  faq: {
    id: number;
    question: string;
    answer: string;
  };
}>();
</script>

<template>
  <AccordionItem
    :value="String(faq.id)"
    class="bg-background-secondary rounded-xl"
  >
    <AccordionHeader>
      <AccordionTrigger
        class="flex w-full justify-between p-4 rounded-xl group"
      >
        <p class="font-bold text-left">{{ faq.question }}</p>
        <ChevronDown
          class="text-icon-brand transition-transform shrink-0 group-data-[state=open]:rotate-180"
        />
      </AccordionTrigger>
    </AccordionHeader>
    <AccordionContent
      class="overflow-hidden data-[state=open]:animate-accordion-open data-[state=closed]:animate-accordion-close"
    >
      <div class="px-4 pb-4 faq-body" v-html="faq.answer" />
    </AccordionContent>
  </AccordionItem>
</template>
